import { render, staticRenderFns } from "./CustomIconPicker.vue?vue&type=template&id=bfc6de28&scoped=true&"
import script from "./CustomIconPicker.vue?vue&type=script&lang=js&"
export * from "./CustomIconPicker.vue?vue&type=script&lang=js&"
import style0 from "./CustomIconPicker.vue?vue&type=style&index=0&id=bfc6de28&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfc6de28",
  null
  
)

export default component.exports